// noinspection TypeScriptUnresolvedReference

import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import Networkgraph from "highcharts/modules/networkgraph";
import Accessibility from "highcharts/modules/accessibility";

// Define interfaces for our data structure
interface ChartNode {
    id: string;
    name: string;
    count?: number;
    isEgo: boolean;
    inCurrentDiary: boolean;
}

interface ChartLink {
    from: string;
    to: string;
}

interface ChartParams {
    nodes: ChartNode[];
    links: ChartLink[];
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    $(function () {
        // Initialize Highcharts modules
        Networkgraph(Highcharts);
        Accessibility(Highcharts);

        // Define colors for different node types
        const COLOR_EGO = "#E8544E";
        const COLOR_IN_CURRENT_DIARY = "#FFD265";
        const COLOR_DEFAULT = "#A0A0A0";

        // Chart params
        const chartContainer = document.getElementById('chart-container');
        const hasChartContainer = chartContainer !== null && chartContainer !== undefined;
        if (!hasChartContainer) {
            return;
        }
        const containerWidth = chartContainer.offsetWidth;
        let chartParams: ChartParams;
        try {
            const chartParamsAttr = chartContainer.getAttribute('data-chart-params');
            chartParams = JSON.parse(chartParamsAttr);
        } catch (e) {
            console.error('Failed to parse chart parameters', e);
            return;
        }

        // Find the maximum count for scaling node sizes
        let maxCount = 1;
        chartParams.nodes.forEach(node => {
            if (node.count && node.count > maxCount) {
                maxCount = node.count;
            }
        });

        // Prepare nodes for Highcharts
        const nodes: Highcharts.SeriesNetworkgraphNodesOptions[] = chartParams.nodes.map(node => {
            // Calculate radius based on count
            const radiusFactor = 8;
            const egoFactor = 1.7; // Ego is larger than other nodes
            const countFactor = node.isEgo ? egoFactor : node.count ? node.count / maxCount : 0;
            const radius = countFactor * radiusFactor;

            let color = COLOR_DEFAULT;
            if (node.isEgo) color = COLOR_EGO;
            else if (node.inCurrentDiary) color = COLOR_IN_CURRENT_DIARY;

            // Fix ego node in the center
            const fixed = node.isEgo
                ? {
                    x: Math.floor(containerWidth / 2.5),
                    y: Math.floor(containerWidth / 1.8),
                }
                : undefined;

            console.log(`Fixed position for ego node: ${fixed ? JSON.stringify(fixed) : 'not fixed'}`);

            return {
                id: node.id,
                name: node.name,
                marker: {radius},
                color,
                custom: {
                    isEgo: node.isEgo,
                    inCurrentDiary: node.inCurrentDiary,
                    count: node.count || 0
                },
                ...(fixed ? {fixed} : {})
            };
        });

        // Prepare links for Highcharts
        const links: [string, string][] = chartParams.links.map((link): [string, string] => {
            return [link.from, link.to];
        });

        const layoutAlgorithm: Highcharts.PlotNetworkgraphLayoutAlgorithmOptions = {
            approximation: "barnes-hut",
            integration: "verlet",
        };

        const options: Options = {
            chart: {
                type: "networkgraph",
                spacing: [15, 0, 15, 0],
                margin: [30, 0, 30, 0]
            },
            title: {
                text: "Ihr Netzwerk",
                useHTML: true,
                style: {
                    fontSize: '16px'
                }
            },
            xAxis: {
                visible: false
            },
            yAxis: {
                visible: false
            },
            tooltip: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            legend: {
                enabled: true,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                itemStyle: {
                    fontWeight: 'normal',
                    fontSize: '10px',
                },
                events: {
                    itemClick: function () {
                        return false; // Disable legend item click
                    }
                }
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        style: {
                            textOutline: 'none',
                            fontSize: '8px',
                            fontWeight: 'normal'
                        }
                    },
                },
                networkgraph: {
                    keys: ["from", "to"],
                    layoutAlgorithm: layoutAlgorithm,
                }
            },
            series: [
                {
                    type: "networkgraph",
                    dataLabels: {
                        enabled: true,
                        linkFormat: "",
                        format: '{point.name}',
                        allowOverlap: true
                    },
                    data: links,
                    nodes: nodes,
                    enableMouseTracking: false
                },
                // Dummy series for legend
                {
                    type: 'scatter',
                    name: 'Sie',
                    color: COLOR_EGO,
                    marker: {radius: 8, symbol: 'circle'},
                    data: [{x: null, y: null}],
                    showInLegend: true,
                    enableMouseTracking: false
                },
                {
                    type: 'scatter',
                    name: 'Ihre Kontakte',
                    color: COLOR_DEFAULT,
                    marker: {radius: 8, symbol: 'circle'},
                    data: [{x: null, y: null}],
                    showInLegend: true,
                    enableMouseTracking: false
                },
                {
                    type: 'scatter',
                    name: 'Heutige Kontakte',
                    color: COLOR_IN_CURRENT_DIARY,
                    marker: {radius: 8, symbol: 'circle'},
                    data: [{x: null, y: null}],
                    showInLegend: true,
                    enableMouseTracking: false
                }
            ],
            responsive: {
                rules: [{
                    condition: {
                        minWidth: 500
                    },
                    chartOptions: {
                        chart: {
                            margin: [45, 0, 45, 0]
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    style: {
                                        fontSize: '10px'
                                    }
                                },
                            }
                        }
                    }
                }]
            }
        };

        // Create the chart
        Highcharts.chart("chart-container", options);
    });
}
